import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dsp-takedown"
export default class extends Controller {
  static targets = ["masterCheckbox", "dspCheckbox"]
  static values = { albumId: Number }

  toggleAll(event) {
    const checked = event.target.checked
    this.dspCheckboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
  }

  updateMasterCheckbox() {
    const allCheckboxes = this.dspCheckboxTargets
    const checkedCheckboxes = this.dspCheckboxTargets.filter(cb => cb.checked)

    if (checkedCheckboxes.length === 0) {
      this.masterCheckboxTarget.checked = false
      this.masterCheckboxTarget.indeterminate = false
    } else if (checkedCheckboxes.length === allCheckboxes.length) {
      this.masterCheckboxTarget.checked = true
      this.masterCheckboxTarget.indeterminate = false
    } else {
      this.masterCheckboxTarget.checked = false
      this.masterCheckboxTarget.indeterminate = true
    }
  }

  takedown() {
    const selectedDsps = this.dspCheckboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.dataset.dspCode)

    if (selectedDsps.length === 0) {
      alert("Please select at least one DSP to takedown")
      return
    }

    if (!confirm(`Are you sure you want to create takedown requests for ${selectedDsps.length} DSP(s)?`)) {
      return
    }

    // Create form and submit
    const form = document.createElement("form")
    form.method = "POST"
    form.action = `/albums/${this.albumIdValue}/takedown`

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const csrfInput = document.createElement("input")
    csrfInput.type = "hidden"
    csrfInput.name = "authenticity_token"
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    // Add selected DSPs
    const dspsInput = document.createElement("input")
    dspsInput.type = "hidden"
    dspsInput.name = "dsp_codes"
    dspsInput.value = JSON.stringify(selectedDsps)
    form.appendChild(dspsInput)

    document.body.appendChild(form)
    form.submit()
  }
}
